<template>
  <el-container>
    <div class="check-confirm">
      <div style="text-align: center">
        <h1 style="font-size: 24px;color: #1b2220;">摄像头测试</h1>
        <p style="font-size: 14px; color: #727272;">根据平台的相关规定，系统需要使用摄像头进行记录学习过程，请注意个人的穿着、隐私以及周边的光线 ！</p>
      </div>
      <div style="text-align: center;margin-top: 40px">
        <div class="check-img">
          <!-- 摄像头-->
          <video id="video" :width="canvasWidth" :height="canvasHeight" style="transform: scaleX(-1)"
                 :style="{'display':imgIsBlock?'block':'none'}"></video>
          <el-image :src="imgSrc" alt="" style="width:231px;height:230px;transform: scaleX(-1);"
                    :style="{'display':imgIsBlock?'none':'block'}"/>
        </div>
        <canvas id="camera" style="display:none;"  :width="canvasWidth" :height="canvasHeight"></canvas>
        <!--检查结果-->
        <div style="padding: 20px;background: #f6f6f6;text-align: left">
          <div>
            <div v-if="isOpenCamera">
              <i class="el-icon-success" style="color: #67C23A;font-size: 22px"></i>
              <span style="margin-left: 4px">摄像头：设备正常工作</span>
            </div>
            <div v-else>
              <i class="el-icon-warning-outline" style="color: #ff4019;font-size: 22px"></i>
              <span style="color: #ff4019;margin-left: 4px">摄像头：设备无法正常工作</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 30px;">
          <el-button type="success" @click="takePhoto">
            摄像头测试
          </el-button>
          <el-button type="success" @click="toVedio" style="margin-left: 15px">
            下一步
          </el-button>
        </div>
        <div style="margin-top: 40px">
          <h3>如果摄像头异常请按以下步骤检查</h3>
          <ul class="check-flow">
            <li>1.请关闭你电脑的杀毒软件、代理VPN等软件，确保网速在100kb/s以上，并刷新页面。</li>
            <li>2.摄像头和麦克风是否连接正常？你可以试试QQ视频聊天是否可以正常进行。</li>
            <li>3.是否在浏览器地址栏左侧弹层启用了摄像头/麦克风权限？
              <img src="../../assets/img/videoTest1.png" width="549" height="158">
            </li>
            <li>4.检查浏览器地址栏附近是否对摄像头/麦克风设置禁用？
              <img src="../../assets/img/videoTest2.png" width="584" height="164">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
  export default {
    name: "EduVideoTest",
    data() {
      return {
        // 摄像机
        video: null,
        camera: null,
        context: null,
        canvasWidth: '231',
        canvasHeight: '230',
        isOpenCamera: false,
        imgSrc: '',
        imgIsBlock:true,
        clickFont: '点击拍照',
        // 摄像机设备数组
        cameraDevices: [],
        selectedDeviceName: '',
        courseId: '',
        sectionId: '',
      }
    },
    methods: {
      // 打开摄像机
      openCamera() {
        this.video = document.getElementById('video');
        this.camera = document.getElementById('camera');
        //this.canvas.getContext('2d').clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context = this.camera.getContext('2d');
        let that = this;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = (constraints) => {
            const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
            if (!getUserMedia) {
              return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
            }
            return new Promise((resolve, reject) => {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          }
        }
        const constraints = { audio: false, video: { width: this.canvasWidth, height: this.canvasHeight} };
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
          if ('srcObject' in that.video) {
            that.video.srcObject = stream
          } else {
            that.video.src = window.URL.createObjectURL(stream)
          }
          that.video.onloadedmetadata = (e) => {
            that.video.play();
            that.isOpenCamera = true;
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 抓拍图片并且上传
       takePhotoAndUpload() {
        this.context.drawImage(this.video, 0, 0, this.canvasWidth, this.canvasHeight);
        const imgSrc = this.camera.toDataURL('image/jpeg');
        this.imgSrc = imgSrc;
      },
      // 转换抓拍图片格式
      dataURLtoFile (dataUrl, filename) {
        let  arr = dataUrl.split(',');
        let  mime = arr[0].match(/:(.*?);/)[1];
        let  bstr = atob(arr[1]);
        let n = bstr.length;
        let  u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      },
      takePhoto() {
        if (!this.isOpenCamera) {
          return;
        }
        // 判断是否已经拍照了
        if (!this.imgIsBlock) {
          this.$confirm('你已拍照成功，是否确定重拍?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.imgIsBlock = true;
            this.clickFont = '点击拍照';
            return;
          })
        }
        this.clickFont = '保存中';
        //进行拍照
        this.takePhotoAndUpload();
        if (this.imgSrc !== '') {
          this.imgIsBlock = false;
          this.clickFont = '保存成功';
        }
      },
      toVedio() {
        this.$router.push({path:`/home/eduVideo/${this.courseId}/${this.sectionId}`});
        // 关闭警告
        // document.getElementsByClassName('el-message')[0].style.display = 'none';
      },
    },
    created() {
      this.courseId = this.$route.params.courseId;
      this.sectionId = this.$route.params.sectionId;
    },
    mounted() {
      //打开摄像头
      this.openCamera();
    },
    beforeRouteUpdate(to, from, next){
      if (this.video.srcObject ){
        this.video.srcObject.getTracks().forEach(function (media) {
          media.stop();
        })
      }
      next();
    },
    beforeRouteLeave(to, from, next){
      if (this.video.srcObject ){
        this.video.srcObject.getTracks().forEach(function (media) {
          media.stop();
        })
      }
      next();
    },
  }
</script>

<style scoped>
  .el-container {
    width: 900px;
    min-width: 900px;
    margin: 35px auto 45px auto;
    border: 1px solid #d6d6d6;
    border-radius: 3px;
    padding: 10px 65px 40px;
    min-height: 650px !important;
  }
  .check-confirm {
    width: 100%
  }
  .check-img {
    overflow: hidden;
    width: 230px;
    height: 230px;
    margin: 0 auto 25px;
    border-radius: 6px;
    border: 5px solid #ccc;
    position: relative;
    background: #3d444c;
  }
  .check-img-upload {
    width: 230px;
    height: 40px;
    background: #63849f;
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    cursor: pointer;
    position: absolute;
    bottom: 0px;
    line-height: 40px;
  }
  .el-button {
    width: 200px;
    background: #25bb9b;
    font-size: 16px;
    border-radius: 5px;
    padding: 12px 0;
  }
  .check-flow {
    background: #f7fbff;
    padding: 40px 85px;
    border: 1px solid #cdd5dd;
    text-align: left;
  }
  .check-flow li {
    color: #3d444c;
    font-size: 14px;
    margin-bottom: 15px;
    list-style: none;
  }
  .check-flow li img {
    margin-top: 15px;
  }
</style>
